import MarkerClusterer from '@google/markerclustererplus';
import Option from './option';

export default {
  environment: process.env.REACT_APP_HOST_ENV || 'local',
  host: process.env.REACT_APP_HOST,
  apiHost: process.env.REACT_APP_API_HOST,
  wpApiHost: process.env.REACT_APP_WP_API_HOST,
  appId: process.env.REACT_APP_APP_ID,
  google: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    oauthClientId: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
    cluster: {
      gridSize: Option.risky(() =>
        Number(process.env.REACT_APP_GOOGLE_MAPS_CLUSTER_GRID_SIZE)
      ).getOrElse(() => 60),
      minimumClusterSize: Option.risky(() =>
        Number(process.env.REACT_APP_GOOGLE_MAPS_CLUSTER_MIN_CLUSTER_SIZE)
      ).getOrElse(() => 10),
      batchSize: Option.risky(() =>
        Number(process.env.REACT_APP_GOOGLE_MAPS_CLUSTER_BATCH_SIZE)
      ).getOrElse(() => MarkerClusterer.BATCH_SIZE),
      batchSizeIE: Option.risky(() =>
        Number(process.env.REACT_APP_GOOGLE_MAPS_CLUSTER_BATCH_SIZE_IE)
      ).getOrElse(() => MarkerClusterer.BATCH_SIZE_IE),
    },
  },
  facebook: {
    apiVersion: process.env.REACT_APP_FACEBOOK_API_VERSION,
    appId: process.env.REACT_APP_FACEBOOK_APP_ID,
  },
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
  recaptcha: {
    siteKey: process.env.REACT_APP_RECAPTCHA_KEY,
  },
  apple: {
    clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
    scopes: process.env.REACT_APP_APPLE_SCOPES,
    redirectUrl: process.env.REACT_APP_APPLE_REDIRECT_URI,
  },
  directory: {
    resultsPerPage: 12,
  },
};
